import { ExportTaxRatesValuesModalComponent } from '../components/export-tax-rates-values-modal/export-tax-rates-values-modal.component';
import { AdminMenuItem } from '../models';
import { adminRoutes } from './admin.routes';

export const adminMenuItems: AdminMenuItem[] = [
  {
    titleTranslateKey: 'admin.dashboard.clientsTitle',
    descriptionTranslateKey: 'admin.dashboard.clientsDescription',
    icon: 'icon-engagement-outline',
    route: adminRoutes.clients,
  },
  {
    titleTranslateKey: 'admin.dashboard.usersTitle',
    descriptionTranslateKey: 'admin.dashboard.usersDescription',
    icon: 'icon-community-outline',
    route: adminRoutes.users.root,
  },
  {
    titleTranslateKey: 'admin.dashboard.residencyJurisdictionsTitle',
    shortTitleTranslateKey: 'admin.dashboard.residencyJurisdictionsTitleShort',
    descriptionTranslateKey:
      'admin.dashboard.residencyJurisdictionsDescription',
    icon: 'icon-list-view-outline',
    route: adminRoutes.residencyJurisdictions,
  },
  {
    titleTranslateKey: 'admin.dashboard.investmentJurisdictionsTitle',
    shortTitleTranslateKey: 'admin.dashboard.investmentJurisdictionsTitleShort',
    descriptionTranslateKey:
      'admin.dashboard.investmentJurisdictionsDescription',
    icon: 'icon-data-outline',
    route: adminRoutes.investmentJurisdictions,
  },
  {
    titleTranslateKey: 'admin.dashboard.generalRatesRuleEngineTitle',
    descriptionTranslateKey:
      'admin.dashboard.generalRatesRuleEngineDescription',
    icon: 'icon-budget-outline',
    route: adminRoutes.generalRatesRuleEngine,
  },
  {
    titleTranslateKey: 'admin.dashboard.entityTypesTitle',
    descriptionTranslateKey: 'admin.dashboard.entityTypesDescription',
    icon: 'icon-object-outline',
    route: adminRoutes.entityTypes,
  },
  {
    titleTranslateKey: 'admin.dashboard.securityTypesTitle',
    descriptionTranslateKey: 'admin.dashboard.securityTypesDescription',
    icon: 'icon-grow-revenue-outline',
    route: adminRoutes.securityTypes,
  },
  {
    titleTranslateKey: 'admin.dashboard.rulesManagerTitle',
    descriptionTranslateKey: 'admin.dashboard.rulesManagerDescription',
    icon: 'icon-network-outline',
    route: adminRoutes.rulesManager,
  },
  {
    titleTranslateKey: 'admin.dashboard.exportTaxRateValues',
    descriptionTranslateKey: 'admin.dashboard.exportTaxRateValuesDescription',
    icon: 'icon-analysis-outline',
    route: adminRoutes.exportTaxRateValues,
    modalComponent: ExportTaxRatesValuesModalComponent,
  },
];
